<template>
  <!-- Start Home Section -->
  <section class="home">
    <!-- Start Overlay -->
    <div class="overlay">
      <!-- Start Container -->
      <div class="container">
        <!-- Start Row -->
        <div class="row align-items-center">
          <!-- Start Column -->
          <div class="col-sm-12 col-lg-6">
            <!-- Start Template Caption -->
            <div class="template-caption">
              <h1>
                AX<span>IT</span>
              </h1>
              <p class="lead">MODERN TEMPLATE FOR BEAUTIFUL PROTOTYPES</p>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.</p>
              <button class="btn-download">Download</button>
            </div>
            <!-- End Template Caption -->
          </div>
          <!-- End Column -->
          <!-- Start Column -->
          <div class="col-sm-12 col-lg-6">
            <div class="begin-form text-center">
              <form @submit.prevent>
                <h4>
                  Try Your <span class="text-uppercase">Free</span> Trial Today
                </h4>
                <input type="text" placeholder="Name" required class="form-control" />
                <input type="email" placeholder="Email" required class="form-control" />
                <input type="password" placeholder="Password" required class="form-control" />
                <button type="submit" class="btn btn-lg form-control">Get Started</button>
              </form>
            </div>
          </div>
          <!-- End Column -->
        </div>
        <!-- End Row -->
      </div>
      <!-- End Container -->
    </div>
    <!-- End Overlay -->
  </section>
  <!-- End Home Section -->
</template>

<style scoped lang="scss">

  .home{
    background-image: url("../../assets/images/header.jpg");
    background-size: cover;
    color: #FFF;
    .container{
      min-height: inherit;
      .row{
        min-height: inherit;
        .template-caption{
          h1{
            font-size: 80px;
            span{
              color: var(--main-color)
            }
          }
          p:first-of-type{
            font-size: 40px;
            position: relative;
            &::after{
              content: '';
              position: absolute;
              width: 100px;
              height: 3px;
              bottom: -20px;
              left: 0;
              background-color: var(--main-color);
              @media(max-width: 991px) {
                left: calc(50% - 50px)
              }
            }
          }
          p:last-of-type{
            color: #CCC;
            line-height: 1.8;
            margin: 40px 0;
            @media(max-width: 576px){
              margin-bottom: 20px;
            }
          }
          button.btn-download{
            background-color: transparent;
            color: #FFF;
            border: 1px solid #FFF;
            padding: 3px 15px;
            transition: .5s;
            &:hover{
              background-color: #FFF;
              color: #000
            }
          }
          @media(max-width: 991px){
            margin-bottom: 20px;
            text-align: center;
          }
        }
        .begin-form{
          form{
            width: 75%;
            margin-left: auto;
            background-color: #FFF;
            border-radius: 5px;
            overflow: hidden;
            h4{
              background-color: #EEE;
              color: #000;
              font-size: 20px;
              padding: 15px 0;
              margin-bottom: 30px;
              span{
                color: var(--main-color)
              }
            }
            input{
              margin: {
                left: auto;
                right: auto;
                bottom: 30px;
              };
              font-size: 15px;
              width: 80%;
              border: none;
              border-bottom: 1px solid #CCC
            }
            button{
              font-size: 18px;
              border-radius: 0;
              color: #FFF;
              padding: 13px 0;
              background-color: #f0ad4e;
              border-color: #eea236;
              &:hover{
                background-color: #ec971f;
                border-color: #d58512;
              }
            }
            @media(max-width: 991px){
              margin: 50px auto
            }
          }
        }
        @media(max-width: 991px){
          flex-direction: column;
        }
      }
    }
  }

</style>

<script>

export default {
  
  name: 'Home',

  mounted: function () {

    /* Handling The Height For Section HTML Element */

      const homeSectionElement = document.querySelector("section.home")

      const headerElement = document.querySelector("header")

      const footerElement = document.querySelector("footer")

      homeSectionElement.setAttribute("style",

        `min-height: calc(100vh - ${headerElement.clientHeight + footerElement.clientHeight}px)`)

      /* ------------------------------------------------------------ */

  }

}
</script>
